<template>
  <div class="container">
      <el-select style="width:200px;" v-model="type" @change="typeSelectChange">
          <el-option label="激活码" :value="1"></el-option>
          <el-option label="代理商订单号" :value="2"></el-option>
          <el-option label="代理商打款单号" :value="3"></el-option>
      </el-select>
      <el-input v-model="content" placeholder="请输入" @input="changeInputValue"></el-input>
  </div>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {
      type: 1,
      content: ''
    }
  },
  mounted () {
  },
  methods: {
    typeSelectChange (value) {
      this.$emit('changeInputType', value)
    },
    changeInputValue (value) {
      this.$emit('changeInputValue', value)
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  margin-right: 10px;
}
</style>
